import { KidsPolicyType } from "@/lib/gql/__generated__/graphql";

export const KIDS_POLICY_DISCOUNT_TYPE = Object.values(KidsPolicyType);

/**
 * 子供の料金タイプ
 */
export const KIDS_POLICY_DISCOUNT_TYPE_VARIABLES = [
	{
		key: "定額料金に設定する",
		value: KidsPolicyType["Static"],
	},
	{
		key: "大人料金の一定割合に設定する",
		value: KidsPolicyType["Ratio"],
	},
	{
		key: "宿泊不可に設定する",
		value: KidsPolicyType["NotAvailable"],
	},
];

export const KIDS_COSLEEPING_POLICY_DISCOUNT_TYPE_VARIABLES = [
	{
		key: "定額料金に設定する",
		value: KidsPolicyType["Static"],
	},
	{
		key: "大人料金の一定割合に設定する",
		value: KidsPolicyType["Ratio"],
	},
];
